import { render, staticRenderFns } from "./TaxIndex.vue?vue&type=template&id=e5b0e81a&scoped=true"
import script from "./TaxIndex.vue?vue&type=script&lang=js"
export * from "./TaxIndex.vue?vue&type=script&lang=js"
import style0 from "./TaxIndex.vue?vue&type=style&index=0&id=e5b0e81a&prod&lang=stylus&scoped=true"
import style1 from "./TaxIndex.vue?vue&type=style&index=1&id=e5b0e81a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5b0e81a",
  null
  
)

export default component.exports